import { fetcher } from '../../../extras/fetcher';
import { ForkliftInspectionInterface } from '../../../types/forkliftInspection.interface';
import { myDateFormat } from '../../../extras/myDateFormat';
import { useEffect, useState } from 'react';

interface Props {
  forkliftId: string;
  timeFromDate?: boolean;
}

export const LastInspectionDate = ({forkliftId, timeFromDate}: Props) => {

  const [dateTime, setDateTime] = useState<Date | null>();


  function timeFromDateWithoutWeekends(date: Date | null | undefined): string {

    if(!date) {
      return '';
    }

    const now = new Date();

    if (date > now) return "0 h";

    let totalHours = 0;

    const cursor = new Date(date);

    while (cursor < now) {
      const day = cursor.getDay(); // 0 = niedziela, 6 = sobota

      const isWeekend = day === 0 || day === 6;

      if (!isWeekend) {
        totalHours++;
      }

      cursor.setHours(cursor.getHours() + 1);
    }

    if (totalHours < 24) {
      return `${totalHours} h`;
    }

    const days = Math.floor(totalHours / 24);
    const hours = totalHours % 24;

    return hours > 0
      ? `${days} d ${hours} h`
      : `${days} d`;
  }

  const getLastInspectionDate = async (forkliftId: string): Promise<void> => {
    const data = await fetcher(`forklift/inspection/${forkliftId}/last`);
    if(data.status === 403) {
      setDateTime(null);
      return;
    }

    if(data.status === 404) {
      setDateTime(null);
      return;
    }

    const result: ForkliftInspectionInterface = data.result;

    if(!data.result?.createdAt) {
      setDateTime(null)
      return;
    }

    setDateTime(result.createdAt);
  }

  useEffect(() => {
    getLastInspectionDate(forkliftId);
  },[forkliftId]);


  if(timeFromDate) {
    return <>{timeFromDateWithoutWeekends(dateTime)}</>
  }

  return <>{myDateFormat(dateTime)}</>

}
